import React from "react";
import { FormGroup } from "react-bootstrap";
import styles from "../Reference.scss";

export const ReferenceText = props => {
  const { name, firstName, fullName } = props;

  return (
    <FormGroup>
      <div className={styles.subtitle}>Dear {name},</div>

      <div className={styles.subtitle}>
        <b>{fullName}</b>
        &nbsp;named you as a reference as a part of her application to become a
        member of The Second Shift.
      </div>

      <div className={styles.subtitle}>
        The Second Shift is a platform that connects our business partners with
        the leading network of women working independently.
      </div>

      <div className={styles.subtitle}>
        Please fill out the form below, based on your experience working
        with&nbsp;
        {firstName}. Please be aware that {firstName}
        &nbsp;will not see your answers, nor will any potential companies.
      </div>

      <div className={styles.subtitle}>
        We thank you for your candor and your assistance in helping&nbsp;
        {firstName} with her application. If you have any questions about this
        or The Second Shift, please{" "}
        <a target="_blank" href="https://thesecondshift.com/contact-us">
          contact us
        </a>
        .
      </div>

      <div className={styles.subtitle}>
        Thank you,
        <br />
        The Second Shift Team
      </div>
    </FormGroup>
  );
};



// WEBPACK FOOTER //
// ./src/routes/admin/reference/components/Reference/ReferenceText.js